'use client';

import dynamic from 'next/dynamic';

const JupiterContainer = dynamic(() =>
	import('../jupiter-container').then(m => m.JupiterContainer)
);

export const JupiterShell = ({
	children
}: {
	children: React.ReactNode,
}) => {
	return (
		<JupiterContainer>
			{children}
		</JupiterContainer>
	);
};